import { render, staticRenderFns } from "./ProductItemShowCard.vue?vue&type=template&id=3f6f0c76&"
import script from "./ProductItemShowCard.vue?vue&type=script&lang=js&"
export * from "./ProductItemShowCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports